// LoadingSpinner.js
import React from 'react';
import './Loading.css'; // Create this CSS file

const Loading = () => {
  return (
    <div className="loading-spinner">
      <div className="spinner"></div>
    </div>
  );
};

export default Loading;
